import { generateInitialState } from 'modules/statistics/reducer/data/selfServiceDetails/status/utils';
import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../../../actionTypes';

/**
 * @typedef {{[requestType in keyof SelfServiceRequestType]: Array<DetailSelfServiceResponse>}} State
 */
/** @type {State} */
const initialState = generateInitialState([]);

/**
 * @param {State} state
 * @param {import('modules/statistics/types').FetchSelfServiceStatisticsSuccessAction} action
 * @returns {State}
 */
const updateAllData = (state, { payload }) =>
  Object.entries(payload).reduce((acc, [type, data]) => ({ ...acc, [type]: data }), state);

export default createReducer(initialState, {
  [types.FETCH_DETAILS_SELF_SERVICE_STATS_SUCCESS]: updateAllData,
});
